import Loading from 'components/common/loading'
import moment from 'moment'
import { Button, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { updateStatusWhitelist } from 'services/admin'
import { IStatusData, IWhitelist } from 'services/type'
import { selectNetwork } from 'store/network/selectors'
import { selectWhitelist } from 'store/whitelist/selectors'
import { linkToProfile, linkToTwitter } from 'utils/link'

export default function WhitelistData({
  updateData,
}: {
  updateData?: () => void
}) {
  const { t } = useTranslation()
  const { data, isLoading, status, isLoadingSC } = useSelector(selectWhitelist)
  const { networks } = useSelector(selectNetwork)

  async function changeStatus(item: IWhitelist, status: IStatusData) {
    try {
      const network = networks.find((obj) => obj.name === item.network)
      if (!network) return

      const rest = await updateStatusWhitelist({
        address: item.walletAddress,
        status,
        networkId: network.id,
      }).catch(() => {})

      if (!!rest && rest.status >= 200 && rest.status <= 299 && updateData) {
        updateData()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Table className='wa__table'>
      <thead>
        <tr>
          <th>{t('USER_NAME')}</th>
          <th>{t('WALLET_ADDRESS')}</th>
          <th>{t('EMAIL')}</th>
          <th>{t('NETWORK')}</th>
          <th>{t('TWITTER')}</th>

          <th>
            {status == IStatusData.APPROVED && t('WHITELISTED_DATE')}
            {status == IStatusData.DISAPPROVED && t('DISAPPROVAL_DATE')}
          </th>
        </tr>
      </thead>

      <tbody>
        {!isLoading &&
          data.map((obj, i) => (
            <tr key={i}>
              <td>
                <a
                  href={linkToProfile(obj.walletAddress)}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='wa__username text-line'
                >
                  {obj.userName}
                </a>
              </td>
              <td>{obj.walletAddress}</td>
              <td>{obj.email}</td>
              <td>{obj.network}</td>
              <td>
                {!!obj.twitter && (
                  <a
                    href={linkToTwitter(obj.twitter)}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    @{obj.twitter}
                  </a>
                )}
              </td>

              <td>
                {status == IStatusData.PENDING && (
                  <p className='wa__g-action'>
                    <Button
                      className='wa__action'
                      onClick={() => changeStatus(obj, IStatusData.DISAPPROVED)}
                      disabled={isLoadingSC}
                      variant='outline-danger'
                    >
                      {t('DISAPPROVE')}
                    </Button>
                  </p>
                )}

                {(status == IStatusData.APPROVED ||
                  status == IStatusData.DISAPPROVED) &&
                  moment(obj.updatedAt).format('L')}
              </td>
            </tr>
          ))}

        {!isLoading && !data.length && (
          <tr>
            <td colSpan={6}>
              <div className='wa__no-data'>{t('NO_DATA')}</div>
            </td>
          </tr>
        )}

        {isLoading && (
          <tr>
            <td colSpan={6}>
              <div className='wa__loading'>
                <Loading />
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}
